export default __webpack_public_path__ + "static/media/image-1.6a883df7.jpeg";